import { useContext } from 'react';
import { MyContext } from '../Store';
import { trans, getViewName, requestIsJaguar } from '../utils';

import { OrderModal, SaveModal, DownloadModal } from './Modals';

export const Footer = () => {
  const [state] = useContext(MyContext);
  const { productData, selectedView } = state;

  const footerStyles = {
    padding: '9px 12px',
    borderRadius: '5px',
    boxShadow: '0px 0px 50px 2px #eee',
  };

  const modalContainerStyles = {
    marginLeft: 'auto',
    marginRight: '20px',
    display: 'flex',
    gap: '5px',
  };

  return (
    <footer className="footer">
      <div style={footerStyles}>
        {trans('Widok')}: <i>{getViewName(selectedView)}</i>, {trans('Rozmiar')}: <i>{productData.size}</i>
      </div>
      {requestIsJaguar && (
        <div style={modalContainerStyles}>
          <DownloadModal />
          <SaveModal />
        </div>
      )}
      <div>
        <OrderModal />
      </div>
    </footer>
  );
};
